
import { defineComponent, reactive, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { store } from '@/store'
import { subscribeToPlan, onPlanSubscriptionSuccess, cancelSubscription, continueSubscription, redirectTomanageSubscription } from '@/api/tripply/services/subscription.service'
import { toast } from '@/api/tools'
import { Plans } from '@/api/tripply/models'

import SubscriptionPlan from '@/components/subscription/SubscriptionPlan.vue'
import ProCongrats from '@/components/modals/ProCongrats.vue'

export default defineComponent({
  name: 'SubscriptionPlans',
  emits: ['select'],
  components: { SubscriptionPlan, ProCongrats },
  props: {},
  setup() {
    const user = store.user.get(state => state.user)
    const subscription = computed(() => store.user.state.subscription)
    const { t } = useI18n()
    const router = useRouter()
    
    const state = reactive({
      loading: false,
      activating: false,
      unsubscribing: false,
      proCongrats: false
    })

    onMounted(async () => {
      const query = router.currentRoute.value.query
      if (query.sessionId) {
        state.activating = true
        await onPlanSubscriptionSuccess(query.sessionId as string)
        state.proCongrats = true
        router.replace({ query: {} })
        toast({title: t('subscription.toast_activated'), type: 'success'})
      }
      if (query.canceled === null) {
        router.replace({ query: {} })
        toast({title: t('subscription.toast_error'), msg: t('subscription.toast_error_desc'), type: 'error'})
      }
    })
    
    async function subscribe(planId: keyof Plans) {
      state.loading = true
      await subscribeToPlan(planId)
    }

    async function reactivateSubscription() {
      state.activating = true
      await continueSubscription()
      toast({title: t('subscription.toast_reactivated'), type: 'success'})
      state.activating = false
    }


    async function unsubscribe() {
      state.unsubscribing = true
      await cancelSubscription()
      toast({title: t('subscription.toast_cancelled'), type: 'success'})
      state.unsubscribing = false
    }

    async function manage() {
      state.loading = true
      await redirectTomanageSubscription()
    }

    return { store, state, subscription, subscribe, unsubscribe, reactivateSubscription, manage, user }
  }
})
